import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../../store/slices/authSlice';
import ErrorLayout from '../components/ErrorLayout';
import { useThemeContext } from '../../../components/ThemeProvider';

const Error401 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { primaryColor } = useThemeContext();

  // Automatically logout user on 401 error
  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  const handleLogin = () => {
    navigate('/login', { replace: true });
  };

  return (
    <ErrorLayout
      code={401}
      title="Unauthorized"
      message="Oturumun süresi doldu veya giriş yapmadın. Korumalı sayfalara erişmek için tekrar giriş yap."
      action={
        <button 
          onClick={handleLogin}
          className="px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
          style={{ backgroundColor: primaryColor || '#1E40AF' }}
        >
          Giriş Yap
        </button>
      }
    />
  );
};

export default Error401;


